import React, { useState, useEffect, useContext, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateRewardCard from "./create/createRewardCard";
import UpdateRewardCard from "./update/updateRewardCard";
import { UserContext } from "../../../App";
import { API } from "../../../services/api";
import axios from "axios";
axios.defaults.baseURL = API;
const RewardCardDataContext = createContext();

function RewardCard() {

  const {userID} = useContext(UserContext);


  const [dataList, setDataList] = useState([]);
  const [ShowData, setShowData] = useState([]);
  const [Data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { name, value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.FirstName.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
        setShowData(results);
      else 
        setShowData(dataList);
    } else 
      setShowData(dataList);
  }

  const openUpdate = (RewardCardID, FirstName, LastName, RewardCardNO, TEL, Email, Identification) => {
    var list = [];
    list.push({
      RewardCardID: RewardCardID,
      FirstName: FirstName,
      LastName: LastName,
      RewardCardNO: RewardCardNO,
      TEL: TEL,
      Email: Email,
      Identification: Identification,
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllRewardCard() {
    axios
      .get("/getAllRewardCard")
      .then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    getAllRewardCard();
  }, []);

  return (
    <RewardCardDataContext.Provider value={{dataList, setDataList, userID, Data, setData, setShowData}}>
      <div className="formContent">
        <CreateRewardCard show={show} onClick={handleClose}/>
        <UpdateRewardCard show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນບັດ RewardCard</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ຊື່</th>
                <th>ນາມສະກູນ</th>
                <th>RewardCardNO</th>
                <th>ເບີໂທ</th>
                <th>Email</th>
                <th>Identification</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                ShowData && ShowData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y+1}</td>
                        <td >{x.FirstName}</td>
                        <td >{x.LastName}</td>
                        <td >{x.RewardCardNO}</td>
                        <td >{x.TEL}</td>
                        <td >{x.Email}</td>
                        <td >{x.Identification}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.RewardCardID} type="button" onClick={() => openUpdate(x.RewardCardID, x.FirstName, x.LastName, x.RewardCardNO, x.TEL, x.Email, x.Identification)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </RewardCardDataContext.Provider>
  );
};

export {RewardCardDataContext};
export default RewardCard;
